export default __webpack_public_path__ + "static/media/evreux7.8677a6e4.jpg";